import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { APP_DRAWER_WIDTH } from './constants';
import { Drawer } from '@biome-design-system/ui/Drawer';

export const BaseAppDrawer = styled(Drawer)`
  & .MuiDrawer-paper {
    background-color: ${fromTheme('color_background')};
    width: ${APP_DRAWER_WIDTH}px;
    @media (max-width: ${fromTheme('screen_medium')}) {
      width: 100vw;
    }
  }
`;
